import React, { useRef } from 'react';

function SimpleAudioPlayer({ audioFile, title, onClose }) {
  const audioRef = useRef(null);
  
  const playbackStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    border: '1px solid black',
    padding: '8px',
    zIndex: 9999,
    fontFamily: 'serif',
    width: '95%',
    maxWidth: '500px',
    boxSizing: 'border-box',
  };

  return (
    <div style={playbackStyle} onClick={(e) => e.stopPropagation()}>
      <table width="100%" border="0" cellSpacing="0" cellPadding="4">
        <tbody>
          <tr>
            <td>
              <b>NOW PLAYING:</b> {title}
            </td>
            <td align="right">
              <button onClick={onClose} style={{background: 'none', border: 'none', padding: 0, color: '#0000FF', textDecoration: 'underline', cursor: 'pointer', fontFamily: 'serif'}}>Close</button>
            </td>
          </tr>
          <tr>
            <td colSpan="2">
              <hr style={{border: 'none', height: '1px', backgroundColor: '#000'}} />
            </td>
          </tr>
          <tr>
            <td colSpan="2">
              <font size="-1"><i>Original file: {audioFile.split('/').pop()}</i></font>
              {title === 'Beijing INTL' && (
                <div style={{marginTop: '8px', padding: '6px', backgroundColor: '#f5f5f5', border: '1px solid #ccc', fontSize: '11px'}}>
                  <b>Note:</b> Connecting flight through Beijing, overheard interesting conversation about AI startups
                </div>
              )}
            </td>
          </tr>
          <tr>
            <td colSpan="2">
              <audio 
                ref={audioRef}
                src={audioFile}
                controls
                style={{width: '100%'}}
                autoPlay
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default SimpleAudioPlayer;
